import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface OpenContactTarget {
  contactId?: string;
  email?: string;
}

interface ContactNavigationState {
  pendingOpenTarget: OpenContactTarget | null;
}

const initialState: ContactNavigationState = {
  pendingOpenTarget: null,
};

const contactNavigationSlice = createSlice({
  name: 'contactNavigation',
  initialState,
  reducers: {
    setOpenContactTarget: (state, action: PayloadAction<OpenContactTarget>) => {
      state.pendingOpenTarget = action.payload;
    },
    clearOpenContactTarget: state => {
      state.pendingOpenTarget = null;
    },
  },
});

export const { setOpenContactTarget, clearOpenContactTarget } = contactNavigationSlice.actions;
export type { OpenContactTarget };
export default contactNavigationSlice.reducer;
